module.exports = __webpack_public_path__ + "img/top-bar.7894c130.png";